/*
 * @Author       : 程哲林
 * @Date         : 2022-06-09 10:11:02
 * @LastEditors  : 程哲林
 * @LastEditTime : 2022-06-13 13:47:21
 * @FilePath     : /mall-fe/src/config/const.ts
 * @Description  : 未添加文件描述
 */
export const HOME_ACT_CK = 'beanActivityUrl';
export const IS_NEW_ACCOUNT_AUTH = 'dubbleAccountLogin';
